import React, { useState } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import Hidden from '@material-ui/core/Hidden';

// core components
import RecentActivity from 'components/RecentActivity';
import GridContainer from 'components/Grid/GridContainer.jsx';
import TabsForUserTrackProfile from 'components/TabsForUserTrackProfile';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import UpdateProfileModal from 'components/UpdateProfileModal';
import UpdateProfilePhotoModal from 'components/UpdateProfilePhotoModal';
import CardBody from 'components/Card/CardBody.jsx';
import CardAvatar from 'components/Card/CardAvatar.jsx';
import ViewMusicImprintButton from 'components/ViewMusicImprintButton';
import LoaderWhite from 'components/LoaderWhite';
import { displayError } from 'store/actions/errorActions';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import { updateUserData } from 'store/actions/userActions';
import DefaultProfile from 'assets/img/default-avatar.png';
import buildAvatarPath from 'utils/buildAvatarPath';
import Store from 'services/StoreService';

const Profile = ({ updateUserData, classes, user, displayError }) => {
  const [photoFormOn, setPhotoFormOn] = useState(false);
  const [profileFormOn, setProfileFormOn] = useState(false);

  const {
    uid,
    avatar,
    photoURL,
    favoriteSongs,
    recentActivity,
    providerToptracks,
  } = user;
  const userAvatar = avatar && buildAvatarPath(avatar);
  const profilePhoto = userAvatar || photoURL || DefaultProfile;

  const onAvatarUploaded = async (avatar) => {
    try {
      await Store.updateUser(uid, { avatar });
      updateUserData({ avatar });
      setPhotoFormOn(false);
    } catch (error) {
      console.log(error);
      displayError('Error saving the new avatar');
    }
  };
  
  const handleProfileFormSubmit = async (profile) => {
    try {
      await Store.updateUser(uid, profile);
      updateUserData(profile);
      setProfileFormOn(false);
    } catch (error) {
      console.log(error);
      displayError('Error saving the new profile');
    }
    };

  return (
    <GridContainer>
      <GridItem xs={12}>
        {!uid ? (
          <LoaderWhite />
        ) : (
          <div>
            <GridContainer>
              <GridItem
                style={{
                  margin: '0px -30px',
                  width: '117%',
                }}
              >
                <Card
                  profile
                  style={{
                    borderRadius: '20px 20px 0px 0px',
                  }}
                >
                  <Hidden smUp implementation='css'>
                    <div onClick={() => setPhotoFormOn(true)}>
                      <GridContainer>
                        <GridItem xs={6} md={4} lg={3}>
                          <CardAvatar
                            profile
                            style={{
                              float: 'left',
                              marginLeft: '30px',
                              boxShadow: '0px 0px 10px -5px rgba(0,0,0,0.75)',
                            }}
                          >
                            <img
                              className={classes.profilePic}
                              src={profilePhoto}
                              alt='User Photo'
                            />
                          </CardAvatar>
                        </GridItem>
                      </GridContainer>
                    </div>
                    <CardBody
                      profile
                      style={{
                        textAlign: 'left',
                        margin: '0px 15px 0px 15px',
                      }}
                    >
                      <h4 className={classes.body}>
                        <b>
                          {user.firstName ? user.firstName : null}{' '}
                          {user.lastName ? user.lastName : null}
                        </b>
                      </h4>
                      <p className={classes.description}>
                        {user.email ? user.email : null}
                      </p>
                      {!user.bio && <p className={classes.description}>
                        Edit Your Profile To Add More Info...
                        <br />
                      </p>}
                      {!!user.bio && <p 
                      className={classes.description} 
                      style={{ 
                        color: '#6672e5',
                        fontSize: '17px', 
                        fontWeight: 'bold', 
                      }}>
                        {user.bio}
                      </p>}
                    </CardBody>
                    <Button
                      style={{
                        width: '84%',
                        margin: '0px 7% 20px 3%',
                        borderRadius: '50px',
                      }}
                      color='primary'
                      onClick={() => setProfileFormOn(true)}
                    >
                      <b>Edit Profile</b>
                    </Button>
                  </Hidden>
                  <Hidden xsDown implementation='css'>
                    <div onClick={() => setPhotoFormOn(true)}>
                      <GridContainer>
                        <GridItem xs={6} sm={4} md={4} lg={3}>
                          <CardAvatar
                            profile
                            style={{
                              float: 'left',
                              marginLeft: '30px',
                              boxShadow: '0px 0px 10px -5px rgba(0,0,0,0.75)',
                            }}
                          >
                            <img
                              className={classes.profilePic}
                              src={profilePhoto}
                              alt='User Photo'
                            />
                          </CardAvatar>
                        </GridItem>
                      </GridContainer>
                    </div>
                    <CardBody
                      profile
                      style={{
                        textAlign: 'left',
                        margin: '0px 15px 0px 15px',
                      }}
                    >
                      <GridContainer>
                        <GridItem sm={3} md={3}>
                          {user.firstName ? (
                            <h4 className={classes.body}>
                              <b>
                                {user.firstName}{' '}
                                {user.lastName ? user.lastName : null}
                              </b>
                            </h4>
                          ) : (
                            <p className={classes.body}>Full Name</p>
                          )}
                          <p className={classes.description}>
                            {user.bio ? user.bio : 'Bio'}
                          </p>
                        </GridItem>

                        <GridItem sm={4} md={4}>
                          <div style={{ margin: '-70px 0px 20px 20px' }}>
                            <Button
                              style={{
                                width: '200px',
                                margin: '0px 0px 40px 0px',
                                borderRadius: '50px',
                              }}
                              color='primary'
                            >
                              <b>Followers</b>
                            </Button>
                            <p className={classes.description}>
                              {user.email ? user.email : 'Email'}
                            </p>
                          </div>
                        </GridItem>
                        <GridItem sm={4} md={4}>
                          <div style={{ margin: '-70px 0px 20px 0px' }}>
                            <Button
                              style={{
                                width: '200px',
                                margin: '0px 0px 40px 0px',
                                borderRadius: '50px',
                              }}
                              color='primary'
                              onClick={() => setProfileFormOn(true)}
                            >
                              <b>Edit Profile</b>
                            </Button>
                          </div>
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Hidden>
                </Card>
                <div style={{ margin: '-30px 0px -30px 0px' }}>
                  {!!recentActivity && recentActivity.length > 1 && (
                    <RecentActivity list={recentActivity} />
                  )}
                </div>
                <div style={{ background: '#EDEEFB', paddingBottom: '120px' }}>
                  <TabsForUserTrackProfile
                    favoriteSongs={favoriteSongs}
                    providerToptracks={providerToptracks}
                  />
                </div>
              </GridItem>
              {/* UPDATE PROFILE MODAL */}
              <UpdateProfileModal
                user={user}
                open={profileFormOn}
                close={() => setProfileFormOn(false)}
                handleSubmit={handleProfileFormSubmit}
              />
              {/* UPDATE PROFILE PHOTO MODAL */}
              <UpdateProfilePhotoModal
                user={user}
                open={photoFormOn}
                close={() => setPhotoFormOn(false)}
                onError={displayError}
                onSuccess={onAvatarUploaded}
                profilePhoto={profilePhoto}
                currentAvatar={avatar}
              />
            </GridContainer>
            <ViewMusicImprintButton />
          </div>
        )}
      </GridItem>
    </GridContainer>
  );
};

export default compose(
  connect(({ user }) => ({ user }), {
    displayError,
    updateUserData,
  }),
  withStyles(Style)
)(Profile);
